import { render, staticRenderFns } from "./VMenuWrapper.vue?vue&type=template&id=5900d6e4"
import script from "./VMenuWrapper.vue?vue&type=script&lang=js"
export * from "./VMenuWrapper.vue?vue&type=script&lang=js"
import style0 from "./VMenuWrapper.vue?vue&type=style&index=0&id=5900d6e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports